'use client';

import { useMemo } from 'react';
import { ScreenType } from '@/types/enums/media';
import { useMediaQuery, useTheme } from '@mui/material';

export interface WindowDimensions {
    width: number | undefined;
    height: number | undefined;
    screenType: ScreenType | undefined;
}

export const useWindowDimensions = (): WindowDimensions => {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    // MUI's down('md') is exclusive of the md value (max-width: md-0.05px).
    // Add an equality media query for exactly md px to make Tablet inclusive of md.
    const mdValue = theme.breakpoints.values.md;
    const isTabletDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const isExactlyMd = useMediaQuery(`(width:${mdValue}px)`);
    const isTablet = isTabletDownMd || isExactlyMd;
    const isDesktopOrAbove = useMediaQuery(theme.breakpoints.up('lg'));

    const screenType = useMemo<ScreenType | undefined>(() => {
        if (isMobile) return ScreenType.Mobile;
        if (isTablet) return ScreenType.Tablet;
        if (isDesktopOrAbove) return ScreenType.Desktop;
        return undefined;
    }, [isMobile, isTablet, isDesktopOrAbove]);

    // Keep the return shape stable with undefined values for potential future use
    return {
        width: undefined,
        height: undefined,
        screenType,
    };
};
